// extracted by mini-css-extract-plugin
export default {"main":"Layout_main__frkoQ","main1":"Layout_main1__OKfw7","left-panel":"Layout_left-panel__kXI+8","collapsed":"Layout_collapsed__QUXN+","right-panel":"Layout_right-panel__5rdAc"};